// extracted by mini-css-extract-plugin
export default {"main":"RenewPackage_main__gmcZG","row":"RenewPackage_row__eYh-U","middle":"RenewPackage_middle__ErAgd","btn":"RenewPackage_btn__g2b6q","image":"RenewPackage_image__qfcKT"};